export const WARRANTY_CLAIMS_LIST_FILTERED = "WARRANTY_CLAIMS_LIST_FILTERED";
export const WARRANTY_CLAIMS_LIST_FILTERED_SUCCESS = "WARRANTY_CLAIMS_LIST_FILTERED_SUCCESS";
export const WARRANTY_CLAIMS_LIST_FILTERED_ERROR = "WARRANTY_CLAIMS_LIST_FILTERED_ERROR";
export const WARRANTY_CLAIMS_IMPORT = "WARRANTY_CLAIMS_IMPORT";
export const WARRANTY_CLAIMS_IMPORT_SUCCESS = "WARRANTY_CLAIMS_IMPORT_SUCCESS";
export const WARRANTY_CLAIMS_IMPORT_ERROR = "WARRANTY_CLAIMS_IMPORT_ERROR";
export const WARRANTY_CLAIMS_ARCHIVE = "WARRANTY_CLAIMS_ARCHIVE";
export const WARRANTY_CLAIMS_ARCHIVE_SUCCESS = "WARRANTY_CLAIMS_ARCHIVE_SUCCESS";
export const WARRANTY_CLAIMS_ARCHIVE_ERROR = "WARRANTY_CLAIMS_ARCHIVE_ERROR";
export const WARRANTY_CLAIMS_UNARCHIVE = "WARRANTY_CLAIMS_UNARCHIVE";
export const WARRANTY_CLAIMS_UNARCHIVE_SUCCESS = "WARRANTY_CLAIMS_UNARCHIVE_SUCCESS";
export const WARRANTY_CLAIMS_UNARCHIVE_ERROR = "WARRANTY_CLAIMS_UNARCHIVE_ERROR";